import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=7bff9b89&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=7bff9b89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff9b89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bff9b89')) {
      api.createRecord('7bff9b89', component.options)
    } else {
      api.reload('7bff9b89', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=7bff9b89&scoped=true&", function () {
      api.rerender('7bff9b89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/NotFound.vue"
export default component.exports